import React, { useState, useEffect, useId, useCallback} from "react";

import { Link, Navigate, useNavigate, useSearchParams} from "react-router";
import Logo from "./common/Logo";

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
// import Swiper core and required modules
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';        
// IMPORTANTE: Asegúrate de tener estas dos líneas
import 'swiper/css';
import 'swiper/css/pagination';


import Template from "./common/template/Template";
import AlertBox from "./common/template/AlertBox";

import UserService from "../services/user.service";
import AuthService from "../services/auth.service";

//import RenderPuntosForm from "./Puntos"
import VisualFilterButtons from "./common/visuals/VisualFilterButtons";


import RenderAvgOdo from "./common/visuals/RenderAvgOdo";
import RenderPie from "./common/visuals/RenderPie";

import FlashMessage from "./common/FlashMessage";
import Loading from "./common/template/Loading";

import SaveButton from "./common/template/SaveButton";

import { useAuth } from "../context/AuthContext";


const wrapperClass = `w-full h-full relative p-4 mt-16  mb-4 mx-auto  rounded-lg md:rounded-b-none  shadow-md bg-white`;

const isFlashMessage = localStorage.getItem('cmx_flashMessage');
console.log('found a flashMessage in localstorage?',isFlashMessage)

const backUrl = process.env.REACT_APP_BACK_URL;

export default function UxReport () {

    const { user } = useAuth();


   const navigate = useNavigate();
   
   const [flashMessage,setFlashMessage] = useState(false)
   
    const [content, setContent] = useState('');
   
   
    const [loading, setLoading]= useState(false);

    //simple strings for the buttons, choose your own!
    const strSave = `Aceptar y Continuar`;
    const strCancel = `❌ Cancelar `;
    const strClose = `✕ Cerrar`;

     // Destructure the returned array with standard names
    const [searchParams, setSearchParams] = useSearchParams();

    // Use the .get() method to access a specific value
    const serviceId = searchParams.get("sId");
    
    // Example of using the setter function
    const updateServiceId = (newId) => {
      setSearchParams({ serviceId: newId });
    };

    const [error, setError] = useState(false)

    

    useEffect(() => {

      //this blocks the app from scrolling
      //document.body.style.overflow = "hidden";
        
      try { 

        UserService.getService(serviceId, user).then(

            (response) => {

              console.log(content);
              
              console.log(response);
              //console.log(response.status);
              if(response  ){
                  console.log(response)
                  setContent(response.data);

              } else {
                navigate('/login')
              }

              
            
            },

            (error) => {
              console.log(error)
              const _content =
                (error?.response && error?.response.data) ||
                error?.message ||
                error?.toString();
              
              setError(_content);
              
              
            
            }
          
        )
          
      } catch (error) {

        console.log(error)
        //navigate("/login")
          
      } finally {
        if(isFlashMessage){
          setFlashMessage(isFlashMessage);
        }
      }
        
     //console.log(flashMessage)
      // Clean up the event listener when the component unmounts
      return () => {
        //this is the reset state of the scroll blocking above
        //document.body.style.overflow = "scroll"
 

    };
  
    }, [] );

    

    const CancelButton = ({className, children}) => {

      const [loading,setLoading] = useState(false);

      function handleClick(){

        setLoading(true);
        handleCancel();

      }

      return (  
         
        <button  
                type="button"
                className={className ||
                  `m-1 p-2 flex flex-row  
                   rounded-md font-semibold 
                   hover:ring-red-400 ring-1 ring-zinc-200 text-zinc-400  hover:text-red-400 hover:shadow-lg
                  transition-all delay-75
                  `
                } 
                disabled={loading} onClick={handleClick}>
          
          <span className="mx-1 text-xs font-thin hover:no-underline">{children}</span>
            
        </button>
  
      );
    } 
    
    function handleCancel (){
      
        
         
         localStorage.setItem('cmx_flashMessage',JSON.stringify({
            message: 'Evaluacion cancelada por el usuario. Atención: no olvide terimnar la evaluacion más adelante  ya que el tiempo seguira transcurriendo.',
            type: 'warning',
          }));
       
        
        console.log('cancelled by the user');
       
        setContent(false); 
        navigate(-1);
        
      
    }

    const BackButton = ({className, children}) => {

      const [loading,setLoading] = useState(false);

      function handleClick (){
      
       
        
        
        navigate(-1);
        
        
      
      }
    
      return (        
  
  
        <button  
                type="button"
                className={className +
                  `m-1 p-2 
                   rounded-md 
                  hover:bg-white bg-zinc-50 border border-zinc-400 font-semibold
                  
                  `
                } 
                disabled={loading} onClick={handleClick}>
          
          <span className="mx-1 text-zinc-400 text-xs font-thin hover:no-underline">{children}</span>
            
        </button>
  
      );
    }     

    const RenderReport = ({})=> { 

      const [visualState,setVisualState] = useState('all');
   
      const visualFilter = visualState;

      return(
            <div className="flex w-full mx-auto overflow-auto my-2">
    
              {content && !loading ? (
                  <>
                    <div className="hidden">
                          {visualFilter === 'tm' && (
                            <>
                                <RenderAvgOdo result={{average:content.ux_avg_this_month*100,n:content.ux_n_this_month}} total={100} legend={`UX Promedio (sobre 100): `}/>
                                <RenderPie groupedData={content.ux_grouped_this_month}/>
                            </>
                          )}
                          {visualFilter === 'all' && (
                            <>
                                <RenderAvgOdo result={{average:content.ux_avg_all*100,n:content.ux_n_all}} total={100} legend={`UX Promedio (sobre 100): `}/>
                                
                                <RenderPie groupedData={content.ux_grouped_all}/>
                            </>
      
                          )} 
                          {visualFilter === '1Y' && (
                            <>
                                <RenderAvgOdo result={{average:content.ux_avg_1y*100,n:content.ux_n_1y}} total={100} legend={`UX Promedio (sobre 100): `}/>
                                <RenderPie groupedData={content.ux_grouped_1y}/>
                            </>
      
                          )}
                          {visualFilter === 'YtD' && (
                            <>
                                <RenderAvgOdo result={{average:content.ux_avg_YtD*100,n:content.ux_n_YtD}} total={100} legend={`UX Promedio (sobre 100): `}/>
                                <RenderPie groupedData={content.ux_grouped_YtD}/>
                            </>
      
                          )} 
                          {visualFilter === '6m'&&(
                            <>
                              <RenderAvgOdo result={{average:content.ux_avg_6m*100,n:content.ux_n_6m}} total={100} legend={`UX Promedio (sobre 100): `}/>
                              <RenderPie groupedData={content.ux_grouped_6m}/>
                            </>
      
                          )} 
                          {visualFilter === '3m'&&(
                            <>
                              <RenderAvgOdo result={{average:content.ux_avg_3m*100,n:content.ux_n_3m}} total={100} legend={`UX Promedio (sobre 100): `}/>
                              <RenderPie groupedData={content.ux_grouped_3m}/>
                            </>
      
                          )} 
                          {visualFilter === '30d'&&(
                            <>
                                <RenderAvgOdo result={{average:content.ux_avg_30d*100,n:content.ux_n_30d}} total={100} legend={`UX Promedio (sobre 100): `}/>
                              <RenderPie groupedData={content.ux_grouped_30d}/>
                            </>
      
                          )}
                    </div>


                    <div className="w-[75vw]  mx-auto overflow-hidden block place-content-start">
                          <Swiper
                                    modules={[Navigation, Pagination, Scrollbar, A11y]}
                                    spaceBetween={50}
                                    slidesPerView={1}
                                      loop={true} 
                                      pagination={{ type: 'bullets', clickable: true }}
                                    onSlideChange={() => console.log('slide change')}
                                  onSwiper={(swiper) => console.log(swiper)}
                          >
                              <SwiperSlide>
                                    <div className="w-full h-[58vh] sm:h-[45vh] md:min-h-[60vh] lg:min-h-[70vh]">
                                        <h4 className="text-sm font-bold text-slate-700">Kpi visual: Odometro de satisfacción (sobre 100%, calificación promedio)</h4>
                                        <VisualFilterButtons visualState={visualState} setVisualState={setVisualState} />
                                    
                                        {visualFilter === 'tm' && (
                                            <>
                                                <RenderAvgOdo result={{average:content.ux_avg_this_month*100,n:content.ux_n_this_month}} total={100} legend={`UX Promedio (sobre 100): `}/>
                                            </>
                                          )}
                                          {visualFilter === 'all' && (
                                            <>
                                                <RenderAvgOdo result={{average:content.ux_avg_all*100,n:content.ux_n_all}} total={100} legend={`UX Promedio (sobre 100): `}/>
                                                
                                            </>
                      
                                          )} 
                                          {visualFilter === '1Y' && (
                                            <>
                                                <RenderAvgOdo result={{average:content.ux_avg_1y*100,n:content.ux_n_1y}} total={100} legend={`UX Promedio (sobre 100): `}/>
                                            </>
                      
                                          )}
                                          {visualFilter === 'YtD' && (
                                            <>
                                                <RenderAvgOdo result={{average:content.ux_avg_YtD*100,n:content.ux_n_YtD}} total={100} legend={`UX Promedio (sobre 100): `}/>
                                            </>
                      
                                          )} 
                                          {visualFilter === '6m'&&(
                                            <>
                                              <RenderAvgOdo result={{average:content.ux_avg_6m*100,n:content.ux_n_6m}} total={100} legend={`UX Promedio (sobre 100): `}/>
                                            </>
                      
                                          )} 
                                          {visualFilter === '3m'&&(
                                            <>
                                              <RenderAvgOdo result={{average:content.ux_avg_3m*100,n:content.ux_n_3m}} total={100} legend={`UX Promedio (sobre 100): `}/>
                                            </>
                      
                                          )} 
                                          {visualFilter === '30d'&&(
                                            <>
                                                <RenderAvgOdo result={{average:content.ux_avg_30d*100,n:content.ux_n_30d}} total={100} legend={`UX Promedio (sobre 100): `}/>
                                            </>
                      
                                          )}
                                                                  
                                    </div>
                              </SwiperSlide>
                              <SwiperSlide>
                                <div className="w-full min-h-[50vh] md:min-h-[60vh] lg:min-h-[70vh]">
                                  <h4 className="text-sm font-bold text-slate-700">Kpi visual: Pie de Detractores (sobre 100%, detractores vs promotores)</h4>
                                  <VisualFilterButtons visualState={visualState} setVisualState={setVisualState} />
                                    
                                  {visualFilter === 'tm' && (
                                    <>
                                        <RenderPie groupedData={content.ux_grouped_this_month}/>
                                    </>
                                  )}
                                  {visualFilter === 'all' && (
                                    <>
                                        
                                        <RenderPie groupedData={content.ux_grouped_all}/>
                                    </>
              
                                  )} 
                                  {visualFilter === '1Y' && (
                                    <>
                                        <RenderPie groupedData={content.ux_grouped_1y}/>
                                    </>
              
                                  )}
                                  {visualFilter === 'YtD' && (
                                    <>
                                        <RenderPie groupedData={content.ux_grouped_YtD}/>
                                    </>
              
                                  )} 
                                  {visualFilter === '6m'&&(
                                    <>
                                      <RenderPie groupedData={content.ux_grouped_6m}/>
                                    </>
              
                                  )} 
                                  {visualFilter === '3m'&&(
                                    <>
                                      <RenderPie groupedData={content.ux_grouped_3m}/>
                                    </>
              
                                  )} 
                                  {visualFilter === '30d'&&(
                                    <>
                                      <RenderPie groupedData={content.ux_grouped_30d}/>
                                    </>
              
                                  )}

                                </div>
                              </SwiperSlide>
                              <SwiperSlide>
                                  <div className="w-full min-h-[50vh] md:min-h-[60vh]">
                                        <hr/>
                                      <div id="good-idea" className="w-full  flex flex-row  m-0 p-2 rounded-xl bg-cyan-400 bg-opacity-15 text-cyan ">
                                                                            <span className="text-3xl">💡</span>
                                                                            <span className="text-[11px] md:text-xs text-cyan-700 font-light">Para acumular puntos complete cursos. Si no aparecen cursos, pida a su administrador que se afilie a más cursos;</span>
                                      </div> 
                                  </div>
                                          
                              </SwiperSlide>
                                                                   
                          </Swiper>
                                                           
                                                            
                    </div> 
                  </>
              
    
                ) : (
    
                  <Loading />
    
                )
              }
    
            </div>
      );

  
    }

    console.log('is there a flashMessage',flashMessage)


    return (
        
    <Template > 
      <div 
        className={`      `+wrapperClass}>
          

                      {flashMessage && (
                  
                        <FlashMessage 
                          flashMessage={flashMessage} 
                          
                          setFlashMessage={setFlashMessage} 
                          
                         
                        />
                      
                      )}  

                  <BackButton 
                          className="absolute top-0 right-0 ">
                            {strClose}
                  </BackButton>     
          
                  <div className="flex-col mx-auto md:max-w-[50vw] justify-left w-full mb-2">

                        

                    
                    {content ? (  

                    <div className="flex flex-col w-full  ">

                               
                      
                      <div id="head-eval" className="flex-col  bg-neutral-50 rounded-md border  border-slate-700 p-1 w-full mb-2">
                        
                          <h3 className="m-1                       
                          text-stone-500 text-base md:text-lg 
                            ">
                            📋&nbsp;UX Report&nbsp;&nbsp;
                          </h3>
                          <div className="inline-flex">
                            <p className="text-zinc-600 text-[10px] sm:text-sm font-thin m-1 p-1">
                              <strong className="font-bold">Ubicacion:&nbsp;</strong> {content.ubicacion.name }    
                              
                              
                            </p>

                            <p className="text-zinc-600 text-[10px] sm:text-sm font-thin m-1 p-1">
                              <strong className="font-bold">Servicio:&nbsp;</strong> {content.service.name }                           
                              
                            </p>
                          </div>
                          
                          
                        
                      </div>
                      <div id="ux-report" className="" >                           
                             
                        <RenderReport />
                              
                      </div>
                      
                    </div>

                    ) : (

                      <div className="flex z-50 mx-auto items-center justify-center w-fit rounded-lg bg-opacity-75 bg-black p-3 mt-16">
                            <svg className="animate-spin h-10 w-10 fill-white" viewBox="0 0 24 24">
                              <path opacity="0.3" fillRule="evenodd" clipRule="evenodd" d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" />
                              <path d="M2 12C2 6.47715 6.47715 2 12 2V5C8.13401 5 5 8.13401 5 12H2Z" />
                            </svg>
                            <span className="text-white font-extralight ml-2">Loading...</span>
                      </div>

              
                    )}

                  </div>
                    
                          

                </div>
              
        
    </Template>   
        
    );

} 

  
  



